import { createI18n, type Translated } from '@pinchcrew/core'
import { en } from './en'
import { ms } from './ms'

export type Messages = Translated<typeof en>

const i18n = createI18n<Messages>({ en, ms })

export const { t, locale, setLocale, messages } = i18n
export { type Locale } from '@pinchcrew/core'
export function useI18n() { return i18n }
